import { Box, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import DialogBox from '../Common/Layout/DialogBox';
import React, { useContext, useEffect, useState } from 'react';
import CancelButton from '../Common/Buttons/CancelButton';
import SaveButton from '../Common/Buttons/SaveButton';
import {
  IContact,
  ICventContact,
  useGetMatchedDbContactsByEmailQuery,
  useLinkContactMutation
} from '../../generated/graphql';
import { AppContext } from '../../AppContext';
import { Actions } from '../../enums/ActionEnums';

interface IProps {
  handleClose: () => void;
  cventContact: ICventContact;
}

const CventNameSelectionForm: React.FunctionComponent<IProps> = ({
  handleClose,
  cventContact
}: IProps) => {
  const { dispatch } = useContext(AppContext);

  const [updateLinkedContact, updateLinkedContactResult] = useLinkContactMutation();
  const [matchingContacts, setMatchingContacts] = useState<IContact[] | []>([]);
  const [selectedMatchingContact, setSelectedMatchingContact] = useState<IContact | null>(null);
  const dbMatchingContactsByEmail = useGetMatchedDbContactsByEmailQuery({
    variables: {
      id: cventContact.id,
      input: {
        email: cventContact.email as string
      }
    }
  });
  const showMatchingContacts = matchingContacts.length > 0 || dbMatchingContactsByEmail.loading;

  useEffect(() => {
    if (dbMatchingContactsByEmail.data && dbMatchingContactsByEmail.data?.result) {
      const data = dbMatchingContactsByEmail.data.result as IContact[];
      setMatchingContacts(data);
      setSelectedMatchingContact(data[0]);
    }
  }, [dbMatchingContactsByEmail]);

  const handleMathincgContactChange = (contactName: string) => {
    if (contactName) {
      const matchingContact = matchingContacts.find((c) => c.fullName === contactName);
      if (matchingContact) {
        setSelectedMatchingContact(matchingContact);
      }
    }
  };

  const updateContact = (rowData: ICventContact, is_linked: boolean) => {
    const message = is_linked ? `${rowData.fullName} is linked` : `${rowData.fullName} is unlinked`;
    dispatch({
      type: Actions.ShowMessage,
      payload: {
        severity: 'success',
        text: message
      }
    });
    handleClose();
  };

  const handleLinkContact = (rowData: ICventContact) => {
    const is_linked = !rowData.is_linked;
    if (is_linked) {
      updateLinkedContact({
        variables: {
          id: rowData.id,
          input: {
            email: rowData.email as string,
            id: Number((selectedMatchingContact as IContact).id)
          }
        },
        update() {
          updateContact(rowData, is_linked);
        }
      }).catch((e) =>
        dispatch({
          type: Actions.ShowMessage,
          payload: {
            severity: 'error',
            text: e.message
          }
        })
      );
    }
  };
  return (
    <DialogBox
      id="link-contact-mail-select"
      width={500}
      title="Link Cvent Contact To DB Contact"
      onClose={handleClose}
    >
      {showMatchingContacts ? (
        <Box sx={{ margin: '30px', display: 'flex', flexFlow: 'column', gap: '35px' }}>
          <RadioGroup
            defaultValue={matchingContacts[0]?.fullName}
            onChange={(event) => handleMathincgContactChange(event.currentTarget.value)}
          >
            <FormLabel
              sx={{
                color: (t) => t.palette.primary.main,
                marginTop: '13px',
                marginRight: '40px',
                marginBottom: '25px'
              }}
              component="legend"
            >
              LINK CVENT CONTACT TO DB CONTACT
            </FormLabel>
            {matchingContacts.map((contact, index) => (
              <FormControlLabel
                key={index}
                value={contact.fullName}
                control={<Radio color="primary" disabled={updateLinkedContactResult.loading} />}
                label={contact.fullName}
              />
            ))}
          </RadioGroup>
          <Box className="centralize" sx={{ mt: '25px' }}>
            <CancelButton
              id="cancel-link-contact-button"
              disabled={updateLinkedContactResult.loading}
              onClick={handleClose}
              text="Cancel"
            />
            <SaveButton
              id="save-link-contact-button"
              disabled={updateLinkedContactResult.loading || dbMatchingContactsByEmail.loading}
              onClick={() => handleLinkContact(cventContact as ICventContact)}
              text="Link"
            />
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            margin: '30px',
            display: 'flex',
            flexFlow: 'column',
            gap: '35px',
            color: (t) => t.palette.error.main,
            textAlign: 'center',
            fontWeight: 'bolder'
          }}
        >
          {'THERE ARE NO MATCHING CONTACTS IN DATABASE!'}
        </Box>
      )}
    </DialogBox>
  );
};

export default CventNameSelectionForm;
